import {useLands} from '#/hooks/query/use-lands';
import {apiWishlistRequests} from '#/repository/api-wishlist-requests';
import {useQuery} from '@tanstack/react-query';

export const useAccountWishlist = (account: string | null | undefined) => {
  const landsQuery = useLands();

  const wishlistLandIdsQuery = useQuery({
    queryKey: ['wishlist', account],
    queryFn: () =>
      apiWishlistRequests.get({
        account: account!,
      }),
    enabled: !!account,
  });

  return {
    data: (landsQuery.data || []).filter(land => wishlistLandIdsQuery.data?.includes(land.id)),
    isLoading: landsQuery.isLoading || wishlistLandIdsQuery.isLoading,
    error: landsQuery.error || wishlistLandIdsQuery.error,
    refetch: wishlistLandIdsQuery.refetch,
  };
};
